import apiClient from '../network/apiClient'
import ShowNotifications from '../utils/notification'

class CurrencyProvider {
  async getCurrencies(params) {
    try {
      const response = await apiClient.get("/currency", { params });
      if (response.status === 200 || response.status === 201) {
        return {
          response: response.data,
          status: true
        };
      } else {
        return { status: false };
      }
    } catch (error) {
       return { status: false };
    }
  }

  async addCurrency(input) {
    try {
      const response = await apiClient.post("/currency", input);
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification(response.data.message, true);
        return { status: true };
      } else {
        ShowNotifications.showAlertNotification('Something went wrong', false);
        return { status: false };
      }
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || "Something went wrong";
      ShowNotifications.showAxiosErrorAlert(message);
      return { status: false };
    }
  }

  async updateCurrency(id, input) {
    try {
      const response = await apiClient.put(`/currency/${id}`, input);
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification(response.data.message, true);
        return { status: true };
      } else {
        ShowNotifications.showAlertNotification('Something went wrong', false);
        return { status: false };
      }
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || "Something went wrong";
      ShowNotifications.showAxiosErrorAlert(message);
      return { status: false };
    }
  }

  async deleteCurrency(id) {
    try {
      const response = await apiClient.delete(`/currency/${id}`);
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification(response.data.message, true);
        return { status: true };
      } else {
        ShowNotifications.showAlertNotification('Something went wrong', false);
        return { status: false };
      }
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || "Something went wrong";
      ShowNotifications.showAxiosErrorAlert(message);
      return { status: false };
    }
  }

  async updateStatus(id, status) {
    try {
      const response = await apiClient.put(`/currency/status/${id}`, { status });
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification(response.data.message, true);
        return { status: true };
      } else {
        ShowNotifications.showAlertNotification('Something went wrong', false);
        return { status: false };
      }
    } catch (error) {
      const message = error?.response?.data?.message || error?.message || "Something went wrong";
      ShowNotifications.showAxiosErrorAlert(message);
      return { status: false };
    }
  }
}

export default new CurrencyProvider();
